import { Injectable } from '@angular/core';
import { UntypedFormArray, UntypedFormGroup } from '@angular/forms';
import { CandidateDocCombined, CandidateDocuments, DocumentType } from 'src/app/core/api.gen';
import { CommonService } from 'src/app/core/common.service';
import { isNotNullOrUndefined, isNullOrUndefined } from '../../../../app/core/utils';
import { BusinessTravel, CountryTypesValues } from '../visatypes/country-types.enum';
import { CommonFormValidations } from './common-form-validations';
import { ValidityTypes } from './validatity-types.enum';
import differenceInCalendarDays from 'date-fns/differenceInCalendarDays';

@Injectable({
    providedIn: 'root'
})
export class MethodValidityService extends CommonFormValidations {

    constructor(public common: CommonService) {
        super(common);
    }
    validateSave(form: UntypedFormArray) {
        const result = this.validateData(form) && this.validateDirty(form);
        return result;
    }

    validateSubmit(form: UntypedFormArray) {
        const result = this.validateData(form) && this.validateMandatory(form);
        if (!result) {
            form.markAllAsTouched();
        }
        return result;
    }

    validateCompletedSubmit(form: UntypedFormArray) {
        const { invalid, ignored } = this.isCompletedDataInvalid(form);
        let validityType = ValidityTypes.NOERROR;
    
        if (invalid.length > 0) {
            form.markAllAsTouched();
            validityType = ValidityTypes.DATAINVALID;
        }
    
        this.common.showValidations(validityType);
    
        return { invalid, ignored }; // Return both invalid controls and ignored fields
    }
    
       
    validateDirty(form: UntypedFormArray) {
        let validityType = ValidityTypes.NOERROR;
        if (!this.isDirty(form)) {
            validityType = ValidityTypes.NOTDIRTY;
        }
        this.common.showValidations(validityType);

        return validityType === ValidityTypes.NOERROR ? true : false;
    }

    validateData(form: UntypedFormArray) {
        let validityType = ValidityTypes.NOERROR;
        if (this.isDataInvalid(form)) {
            validityType = ValidityTypes.DATAINVALID;
        }
        this.common.showValidations(validityType);

        return validityType === ValidityTypes.NOERROR ? true : false;
    }

    trimNotesAndComments(text: string) {
        if (!isNullOrUndefined(text)) {
            text = text.trim();
            if (text.length === 0) {
                text = null;
            }
        } else { text = null; }
        return text;
    }

    validateMultipleForms(form: UntypedFormArray[]) {
        const validityType = ValidityTypes.INVALID;
        // ex: if all forms in the array are invalid then res = [true, true, ..]
        const res = form.map(f => this.isInvalid(f));
        // finding if there is any true (invalid form) and returning the !of hence forms are invalid else !undefined (true)
        if (res.find(item => item === true)) {
            this.common.showValidations(validityType);
            return false;
        } else {
            return true;
        }

    }

    incorrectDataMulForms(forms: UntypedFormArray[]) {
        const validityType = ValidityTypes.DATAINVALID;
        // ex: if all forms in the array are invalid then res = [true, true, ..]
        const res = forms.map(f => this.isDataInvalid(f));
        // finding if there is any true (invalid form) and returning the !of hence forms are invalid else !undefined (true)
        if (res.find(item => item === true)) {
            this.common.showValidations(validityType);
            return false;
        } else {
            return true;
        }
    }

    dirtyMulForms(forms: UntypedFormArray[]) {
        const validityType = ValidityTypes.NOTDIRTY;
        // ex: if all forms in the array are invalid then res = [true, true, ..]
        const res = forms.map(f => this.isDirty(f));
        // finding if there is any true (invalid form) and returning the !of hence forms are invalid else !undefined (true)
        if (res.find(item => item === true)) {
            return true;
        } else {
            this.common.showValidations(validityType);
            return false;
        }
    }

    validateMandatory(form) {
        let validityType = ValidityTypes.NOERROR;
        if (this.isInvalid(form)) {
            validityType = ValidityTypes.INVALID;
        }
        this.common.showValidations(validityType);

        return validityType === ValidityTypes.NOERROR ? true : false;
    }

    GetIndexOfInvalidForm(formArray: UntypedFormArray): number {
        return formArray.controls.map(control => control.status).findIndex(elem => elem === 'INVALID');
    }
    InvalidFormIndexFind(f: UntypedFormArray): number {
        const arr = ['processor', 'leid'];
        const tab = this.findTab(arr, f);
        return tab;

    }

    docMandatory(uploadedFiles: CandidateDocCombined[]) {

        let missingFiles = uploadedFiles.filter(x => x.isMandatory && !x.isUploaded).
        map(x => x.documentTypeName);

        // const mandatory = uploadedFiles.filter(x => x.isMandatory).map(x => x.docNameId);
        // const available = getdistinctDocs.filter(s => mandatory.includes(s.documentId));

         const anyOneMandatoryTypeIds = uploadedFiles.filter(x => x.mandatoryType > 0).map(x => x.documentTypeId);
         const docTypeIds = uploadedFiles.filter(x => x.mandatoryType > 0 && x.isUploaded).map(x => x.documentTypeId);

        // if (available.length < mandatory.length) {
        //     return false;
        // }

        if (!anyOneMandatoryTypeIds.every(id => docTypeIds.includes(id))) {
            return false;
        }

        if (missingFiles && missingFiles.length > 0) {
            return false;
        }

        return true;
    }

    ifFieldNull(model) {
        if (!model.onboardingType.id ||
            !model.officeLocationCountry.id ||
            !model.employeeCategory.id ||
            !model.contractType.id) {
            return true;
        }

        return false;
    }

    ifNoDocCat(filedetails: CandidateDocuments, docs: DocumentType[]) {
        return docs.filter(x => x.docNameId === filedetails.documentId).length === 0;
    }

    validGivenFields(fields: Array<string>, form: UntypedFormArray) {
        let valid = true;
        fields.forEach(name => {
            const control = form.controls.find(fg => fg.get(name)).get(name)
            if (control && control.invalid) {
                valid = false;
                control.markAsTouched();
            }
        })

        return valid;
    }


    validOnSave(formArray, country: string) {
        switch (country) {
            case CountryTypesValues.SaudiArabia :
                const LegalEntityControl = this.getFormControl(formArray, 'officeLE.id');
                if (LegalEntityControl && LegalEntityControl.invalid) {
                    this.common.showOnSaveValidatons(country);
                    return false;
                }
                return true;
              case CountryTypesValues.PAK:
                const LegalEntityCtrl = this.getFormControl(formArray, 'officeLE.id');
                if (LegalEntityCtrl && LegalEntityCtrl.invalid) {
                    this.common.showOnSaveValidatons(country);
                    return false;
                }
                return true;

            case BusinessTravel.Value:
            case CountryTypesValues.BHR:
            case CountryTypesValues.OMAN:
            case CountryTypesValues.QAT:
            case CountryTypesValues.KWT:
            case CountryTypesValues.UAE:
            case CountryTypesValues.EGY:
            case CountryTypesValues.JOR:
                const LocationControl = this.getFormControl(formArray, 'officeToBeVisited.id');
                if (LocationControl && LocationControl.invalid) {
                    LocationControl.markAsTouched();
                    this.common.showOnSaveValidatons(country);
                    return false;
                }
                return true;
        }
    }

    isExitTypeValid(formArray: UntypedFormArray) {
        const exitTypeControl = this.getFormControl(formArray, 'exitSubType.id');
        if (exitTypeControl && exitTypeControl.invalid) {
            exitTypeControl.markAsTouched();
            return false;
        }
        return true;
    }

    getFormControl(formArray: UntypedFormArray, name: string) {
        const fg = formArray.controls.find(fg => fg.get(name));
        if (fg) {
            return fg.get(name);
        }
    }
    exitInvalidControlTab(f: UntypedFormArray): number {
        const arr = ['offboardingMember', 'nationalityType'];
        const tab = this.findTab(arr, f);
        return tab;
    }

    findTab(arr: any, f: UntypedFormArray): number {
        const ft = 0;
        const st = 1;
        const invalid = [];
        f.controls.forEach((e: UntypedFormGroup) => {
            const controls = e.controls;
            for (const name in controls) {
                if (controls[name] && controls[name].invalid) {
                    invalid.push(name);
                }
            }
        })
        const p = invalid.some(item => arr.includes(item));
        const res = invalid.filter(f => !arr.includes(f));
        if (p && res.length === 0) {
            return st;
        }
        if (res) {
            return ft;
        }


    }

    missionVisaValidation(formArray: UntypedFormArray, id: number) {
        if (id === 6454) {
            const officeToBeVisited = this.getFormControl(formArray, 'officeToBeVisited.id');
            return officeToBeVisited.value !== 661 ? true : false
        }
        return false;

  }

    workPermitVisaValidation(formArray: UntypedFormArray, id: number) {
        if (id === 9204 || id === 9209) {
            const genderEle = this.getFormControl(formArray, 'gender.id');
            const nationalityTypeId = this.getFormControl(formArray, 'nationalityType.id');
            return genderEle.value === 7 && nationalityTypeId.value === 14570? true : false
        }
        return false;
    }

    kuwaitVisaValidation(formArray: UntypedFormArray, id: number) {
        if (id === 9305) {
            const attestedbyKwait = this.getFormControl(formArray, 'attestedbyKwait.id');
           // return attestedbyKwait.value === 2346 ? true : false
           return attestedbyKwait.value === 2347 ? false : true
        }
        return true;

    }
    jordanVisitVisaValidation(formArray: UntypedFormArray, id: number) {
        if (id === 15242) {
            const dateOfTravel = this.getFormControl(formArray, 'dateOfTravel');
            const typeOfVisa = this.getFormControl(formArray, 'typeOfVisa.id');
            const newDateOfTravel: Date = new Date(dateOfTravel.value);
            const datediff = differenceInCalendarDays(newDateOfTravel, new Date());
            return typeOfVisa.value === 15255 && isNotNullOrUndefined(newDateOfTravel) && (0<=datediff && datediff<10) ? true : false
        }
        return false;
    }
    ksaGosiVisaValidation(formArray: UntypedFormArray, id: number){
        if(id===5902 || id===5903) //GOSI Addition or GOSI Removal
        {
            const specialExpat=this.getFormControl(formArray, 'specialExpat');
            const nationality=this.getFormControl(formArray, 'nationality.id');
            const arr = [175, 241, 203, 188, 26, 127] //GCC Countries

            if(!isNullOrUndefined(nationality.value)&& (!isNullOrUndefined(specialExpat.value)))
            {
            // if(specialExpat.value===false)
            // return false;
            if(specialExpat.value===false && !arr.includes(nationality.value))
            return false;
            }          

        }
        return true;
    }

    isImmigrationConsultantValid(formArray: UntypedFormArray) {
        const processor = this.getFormControl(formArray, 'processor.id');
        if (processor && processor.invalid) {
            processor.markAsTouched();
            return false;
        }
        return true;
    }

    isExitLocationAvailable(formArray:UntypedFormArray){
        const location=this.getFormControl(formArray,'officeLocation.id');
        if (location && location.invalid) {
            location.markAsTouched();
            return false;
        }
        return true;
    }

    // CheckUaeGccWork_renewalPbTypeValidation(preboardingid :number, VisaTypeId :number){
    //  if((VisaTypeId === 6457 || VisaTypeId === 6458) && (preboardingid == 1045)){
    //     {
    //       return false;
    //     }
    // }
    // return true;
    // }

}
